import React from 'react';
import { usePermission } from '../../hooks/usePermission';
import { Role } from '../../types';

interface RoleGuardProps {
  roles: Role[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ roles, children, fallback = null }) => {
  const { hasRole } = usePermission();
  return hasRole(...roles) ? <>{children}</> : <>{fallback}</>;
};

export default RoleGuard;
